import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import GlowingOrb from "../ui/GlowingOrb";

const ProtectedRoute = ({ children }) => {
  const { user, isSignedUp, userType, loading, initialAuthCheckDone, crossDomainAuthPending } = useAuth();
  const location = useLocation();

  // Wait for Firebase auth state AND cross-domain auth to complete before making redirect decisions
  if (loading || !initialAuthCheckDone || crossDomainAuthPending) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <GlowingOrb size="md" />
      </div>
    );
  }

  if (location.pathname === "/stripe-callback" || location.pathname === "/stripe-connect-callback") {
    if (user) {
      return children;
    }
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (location.pathname.includes("/settings")) {
    return children;
  }

  if (!isSignedUp) {
    if (userType === "MPS" && location.pathname !== "/mps-signup") {
      return <Navigate to="/mps-signup" />;
    }
  }

  if (isSignedUp && location.pathname === "/mps-signup") {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
